// src/i18n/funds.ts —— C-03 人工调账表单、C-08 充值 / 提现审核文案包（经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06，其余本计划定稿（W-7 回写）。funds / agents 两页共用的新键只在本包定义（agents 包引用）
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_FUNDS: I18nPack = {
  zh: {
    // 06 C-08 [新增 key]
    stDetected: '已检测',
    stConfirming: '确认中',
    stPaying: '支付中', // C-08 / C-12 同键（S-65）
    stVerifyFailed: '验证失败', // C-08 / C-12 同键（S-65）
    slaOverdue: '超时 {h}h', // D26；C-08 / C-12 共用
    bigWdTag: '大额 · 需二级审批',
    waitSecondReview: '待二审',
    cReview1: '一审',
    cReview2: '二审',
    wdFailedTip: '链上验证失败。如财务确认确实已用其他钱包手工付款，可重新登记正确哈希；确认未付款则退回用户余额。',
    wdRefundTitle: '确认退回',
    wdRefundText: '确认该笔未实际付款，将解冻并退回用户余额，状态置为已拒绝。',
    toastFirstApproved: '一审已通过，等待另一名管理员复核',
    toastMarkPaid: '已登记哈希，等待链上验证', // C-08 / C-12 共用
    toastWdRefunded: '已退回用户余额',
    cNetAmount: '净额', // 06 C-12 [新增 key]；多付结案列共用
    // 06 Toast 映射 [改写]
    toastAdjust: '调账已记账并写入操作记录（{biz_no}）',
    toastWdPayout: '已通过，进入财务工作台付款队列（小额自动付款，达到复核阈值的由财务发起并复核）', // 运营 UX 评审 2026-10-15 #13
    // 0038（用户需求 2026-10-15）：按 Console 自动付款额度预告付款方式；Console 读不到财务机硬上限，自动出款一句注明以财务机上限为准
    toastWdAutoPay: '已通过：低于自动付款额度 {t} USDT，将自动出款（以财务机上限为准）',
    toastWdManualPay: '已通过：达到或超过自动付款额度 {t} USDT，需财务在财务工作台发起付款',
    // 以下本计划定稿（W-7 回写）
    tabOverpaid: '多付结案',
    proposeOverpaid: '多付结案',
    errAdjustAmount: '请输入非零金额（最多 6 位小数，可为负）',
    aSettleOverpay: '结清',
    recOpen: '待追回',
    recRecovered: '已追回',
    recWrittenOff: '已核销',
    toastOverpaidProposed: '已提交多付结案，待复核',
    toastOverpaidSettled: '已结清',
    aMarkPaidAgain: '重新登记哈希', // C-08 / C-12 共用
    stPaidWd: '已到账', // 06 C-08 [新增 key]：提币 paid
    fndRefund: '退回', // 06 C-08 行内动作「退回」（原型 aRefund「退款」属 C-17，不借用）
    aMarkPaid: '手工登记已付哈希', // 运营 UX 评审 #13：人工兜底，不触发付款
    netArrive: '到账',
    cConfirmations: '确认数',
    depActualUSDT: '链上实收', depBaseRate: '平台汇率', depAppliedRate: '实际汇率', depPlatformAmount: '平台折算额', depGross: '用户换算额',
    depFeeUSD: '入金手续费', depNetUSD: '用户净入账', depSpread: '代理汇率差',
    cBizNo: '单号',
    cChainAmount: '链上金额',
    cOverpaid: '多付金额',
    cRecovery: '追回状态',
    proposedBy: '发起人',
    errNoteLong: '备注不能超过 255 字', // C-08 / C-12 共用
    adjustTip: '正数入账、负数扣减；正向调账先抵扣交易手续费欠费。',
    err1101: '可用余额不足',
    fndReasonNote: '审核备注（原因）', // 06 C-03 人工调账表单字段原文（base cReason 为「原因」，另起键）
    fndApprovedAt: '通过时间', // 06 C-08 / C-12 抽屉字段
    // 批 8a（审计 O-21）：提币审核抽屉风险结论与地址标签（原硬编码英文 Address）
    fndToAddrWd: '提币收款地址', fndToAddrDep: '平台收款地址', fndFromAddr: '付款地址',
    fndRiskHits: '风控命中', fndAddrFirstSeen: '地址首次使用', fndAddrFlags: '地址风险', fndNone: '无',
    fndFirstYes: '是（此前无人提币到该地址）', fndFirstNo: '否（此前已有提币到该地址）',
    fndRule_withdraw_review: '大额提币二级审批',
    fndFlag_platform_address: '平台内部地址（不得付款，须拒绝）', fndFlag_shared_address: '其他用户也曾提币到此地址', fndFlag_platform_check_unavailable: '平台地址核验暂不可用，请人工核对',
    fndPlatformBlock: '收款地址是平台内部地址，不能通过，请拒绝该提币',
    fndSecondInDrawer: '大额 / 待二审提币须打开详情核对风险后再通过',
  },
  en: {
    stDetected: 'Detected',
    stConfirming: 'Confirming',
    stPaying: 'Paying',
    stVerifyFailed: 'Verification failed',
    slaOverdue: 'Overdue {h}h',
    waitSecondReview: 'Awaiting 2nd review',
    toastFirstApproved: 'First approval recorded; awaiting a second reviewer',
    toastMarkPaid: 'Hash recorded — awaiting on-chain verification',
    toastWdRefunded: 'Refunded to user balance',
    cNetAmount: 'Net',
    toastAdjust: 'Adjustment booked and logged ({biz_no})',
    toastWdPayout: 'Approved — queued in the Finance Console (small amounts auto-paid; large ones need finance review)',
    toastWdAutoPay: 'Approved — below the auto-payout limit of {t} USDT, it will be paid automatically (subject to the Finance host cap)',
    toastWdManualPay: 'Approved — at or above the auto-payout limit of {t} USDT; finance must start the payout in the Finance Console',
    // 以下本计划定稿（06 只给 zh 或未给文案）
    bigWdTag: 'Large · two-step approval',
    cReview1: '1st review',
    cReview2: '2nd review',
    wdFailedTip: 'On-chain verification failed. If finance confirms a manual payment from another wallet, re-record the correct hash; if it was not paid, refund the user.',
    wdRefundTitle: 'Confirm refund',
    wdRefundText: "Confirm this was not actually paid. The amount is unfrozen and returned to the user's balance, and the status becomes Rejected.",
    tabOverpaid: 'Overpaid closes',
    proposeOverpaid: 'Close as overpaid',
    errAdjustAmount: 'Enter a non-zero amount (up to 6 decimals, may be negative)',
    aSettleOverpay: 'Settle',
    recOpen: 'Open',
    recRecovered: 'Recovered',
    recWrittenOff: 'Written off',
    toastOverpaidProposed: 'Overpaid close submitted for review',
    toastOverpaidSettled: 'Settled',
    aMarkPaidAgain: 'Re-record hash',
    stPaidWd: 'Paid',
    fndRefund: 'Refund',
    aMarkPaid: 'Record manual payment hash',
    netArrive: 'Receives',
    cConfirmations: 'Confirmations',
    depActualUSDT: 'On-chain received', depBaseRate: 'Platform rate', depAppliedRate: 'Applied rate', depPlatformAmount: 'Platform equivalent', depGross: 'User converted gross',
    depFeeUSD: 'Deposit fee', depNetUSD: 'Net user credit', depSpread: 'Agent FX spread',
    cBizNo: 'Order no.',
    cChainAmount: 'On-chain amount',
    cOverpaid: 'Overpaid',
    cRecovery: 'Recovery',
    proposedBy: 'Proposed by',
    errNoteLong: 'Note must be at most 255 characters',
    adjustTip: 'Positive amounts credit, negative amounts debit; positive adjustments settle unpaid fees first.',
    err1101: 'Insufficient available balance',
    fndReasonNote: 'Review note (reason)',
    fndApprovedAt: 'Approved at',
    fndToAddrWd: 'Withdrawal destination', fndToAddrDep: 'Platform receiving address', fndFromAddr: 'Sender address',
    fndRiskHits: 'Risk hits', fndAddrFirstSeen: 'First use of address', fndAddrFlags: 'Address risk', fndNone: 'None',
    fndFirstYes: 'Yes (no earlier withdrawal to this address)', fndFirstNo: 'No (earlier withdrawals used this address)',
    fndRule_withdraw_review: 'Large withdrawal two-step review',
    fndFlag_platform_address: 'Platform-owned address (do not pay; reject)', fndFlag_shared_address: 'Other users also withdrew to this address', fndFlag_platform_check_unavailable: 'Platform-address check unavailable; verify manually',
    fndPlatformBlock: 'The destination is a platform-owned address. Do not approve; reject this withdrawal',
    fndSecondInDrawer: 'Large / second-review withdrawals must be approved from the detail drawer after checking risks',
  },
};

// 06 Toast 映射 [改写]：toastAdjust（操作记录 + 单号）、toastWdPayout（D9 不再生成代付单）
export const REWRITES_FUNDS: readonly string[] = ['toastAdjust', 'toastWdPayout'];
